module.exports = __webpack_public_path__ + "static/media/color-spinner.e275bf6b.gif";


//////////////////
// WEBPACK FOOTER
// ./src/images/color-spinner.gif
// module id = 1613
// module chunks = 0